export default class TechademiaCheckOrder {
  private readonly _id: any;
  private readonly _code: string|number;
  private readonly _type: string;
  private readonly _documentName: string|null;
  private readonly _createdAt: Date;
  private readonly _links: object;

  constructor({
    id,
    code,
    type,
    documentName,
    createdAt,
    links,
  }) {
    this._id = id;
    this._code = code;
    this._type = type;
    this._documentName = documentName;
    this._createdAt = new Date(createdAt);
    this._links = links;
  }

  get id(): any {
    return this._id;
  }

  get code(): string|number {
    return this._code
  }
  get documentName(): string|null {
    return this._documentName;
  }

  get createdAt(): Date {
    return this._createdAt;
  }

  get links(): object {
    return this._links;
  }

  isCitationCheck() {
    return this._type === 'citationCheck';
  }

  isGenderBiasCheck() {
    return this._type === 'genderBiasChecks';
  }
}
